import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import VideoSection from "component/landing-page/VideoSection";
import SafeLink from "modules/components/SafeLink";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import commonStyles from "./commonStyles.module.scss";
import styles from "./compare-video-section.module.scss";

interface IProps {
   title: string;
   youtubeId: string;
   heading: string;
   points: string[];
   asPath: string;
   href: string;
   button: string;
}

function CompareVideoSection(props: IProps) {
  const {
    title, youtubeId, points = [], heading, asPath, href, button,
  } = props;
  return (
    <div className={styles.video_section_container}>

      <VideoSection
        videos={[{
          title,
          youtubeId,
        }]}
        title=""
        showThumbnail={false}
        className={styles.video_youtube}
      />

      <div>
        <PAText component="h2" className="m-0 m-t-10 p-0" fontSize={FONT_SIZE[4]} bold>
          {heading}
        </PAText>
        <div className={styles.points}>
          {points.map((eachPoint: string) => (
            <div className="d-flex align-items-center m-t-10" key={eachPoint}>
              <PAImage width={30} height={30} src={getRelativeImagePath("/cms/pubicImages/images/BlueTickMark.webp")} className={styles.tick} />
              <PAText component="h3" className="m-b-10 m-t-10" fontSize={FONT_SIZE[3]}>
                {eachPoint}
              </PAText>
            </div>
          ))}
          <SafeLink href={href} asPath={asPath} className="d-flex m-t-20" style={{ marginLeft: "calc(4 * var(--safari-root-font, 10px))" }}>
            <PAButton buttonType={BUTTON_TYPE.SECONDRY} className={commonStyles.button_style}>
              {button}
            </PAButton>
          </SafeLink>
        </div>
      </div>

    </div>
  );
}

export default CompareVideoSection;
